export default __webpack_public_path__ + "img/eeUXPjlz.f264cdd4.svg";